<template>
  <v-menu :value="menuShow" offset-y nudge-bottom="15" nudge-left="45" rounded="lg" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="defaultColor--text text-capitalize font-weight-regular"
        x-large
        :loading="loading"
        elevation="0"
        style="font-size: 15px"
        color="white"
        rounded
        v-bind="attrs"
        v-on="on"
        @click="menuShow = true"
      >
        {{buttonName}}
        <v-icon size="25" right dark class="ml-3 mr-1">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, index) in items" :key="index">
        <v-menu
          text
          rounded="lg"
          open-on-hover
          bottom
          offset-x
          nudge-right="0"
          nudge-top="15"
          flat
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            @click="clickItem(item)"
              block
              class="text-capitalize"
              text
              color="defaultColor"
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ item.CategoryNameTR }}
              <v-spacer />
              <v-icon
                right
                color="defaultColor"
                v-text="'mdi-chevron-right'"
              ></v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(childItem, i) in item.Children" :key="i">
              <v-btn
                block
                class="text-capitalize text-left"
                text
                color="defaultColor"
                dark
                @click="clickItem(childItem)"
                >{{ childItem.CategoryNameTR }} <v-spacer
              /></v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
        menuShow:false
    };
  },
  props: {
    items: {
        type:Array,
    },
    buttonName: {
        type:String,
        default: ''
    },
    loading: {
        type:Boolean,
        default: false
    },
  },
  mounted() {},
  methods: {
    clickItem(childItem){
        this.menuShow = false
        this.$emit('clickMenu', childItem)
    }
  },
  computed: {},
};
</script>
